import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import objectSupport from 'dayjs/plugin/objectSupport'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
dayjs.extend(objectSupport)
dayjs.extend(utc)

export function toHumanDate(date) {
  return dayjs(date).format('DD.MM.YYYY')
}

export function getMonthName(date) {
  return dayjs(date).format('MMMM')
}

export function shiftByMonthAmount(date, monthAmount) {
  return dayjs(date).add(monthAmount, 'month')
}

export function shiftByDayAmount(date, dayAmount) {
  return dayjs(date).add(dayAmount, 'day')
}

export function now() {
  return dayjs()
}

export function toUtcSeconds(date) {
  return dayjs(date).utc().valueOf()
}

export function parse(date) {
  return dayjs(date, 'YYYY-MM-DD')
}

export function format(date) {
  return dayjs(date).format('YYYY-MM-DD')
}

export function truncateByMonth(date) {
  let dayjsDate = dayjs(date)
  const month = dayjsDate.month()
  const year = dayjsDate.year()
  return dayjs({ year, month })
}

export function isSameMonth(date1, date2) {
  let parsedDay1 = dayjs(date1)
  let parsedDay2 = dayjs(date2)
  return (
    parsedDay1.year() === parsedDay2.year() &&
    parsedDay1.month() === parsedDay2.month()
  )
}

export function getDiffInMonth(date1, date2) {
  const dayjsDate1 = dayjs(date1)
  return Math.ceil(Math.abs(dayjsDate1.diff(date2, 'month', true)) - 1)
}
